import { LINK_TYPES } from '../../link-form/constants';

export const downloadLinks = (links, categories) => {
  const csvString = convertToCSV(links, categories);

  const blob = new Blob(['\ufeff' + csvString], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  const timestamp = new Date().toLocaleString();
  link.setAttribute('download', `portal-all-links-${timestamp}.csv`);

  link.click();
  URL.revokeObjectURL(url);
};

const convertToCSV = (data, categories) => {
  const headers = [
    'type',
    'title',
    'description',
    'persona',
    'linkText',
    'linkUrl',
    'imageUrl',
    'displayLabel',
    'weighting',
    'categories',
    'subcategories',
    'filters',
    'tags',
    'longDescription',
  ];

  const escapeCSV = (val) => {
    if (val == null) {
      return '';
    }

    // split arrays into format of "blah 1, blah 2, blah 3" so they will end up in the same cell e.g. tags or filters
    const stringValue = Array.isArray(val) ? val.join(', ') : String(val);
    if (/[",\n\r]/.test(stringValue)) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  const rows = data.map((item) => {
    const linkTexts = item.links?.[0]?.text || [];
    const linkUrls = item.links?.[0]?.url || [item.url];
    const categoryNames =
      item.categories
        ?.map((cat) => {
          return categories.find((c) => c.id === cat.id)?.title;
        })
        .filter(Boolean) ?? [];

    const subcategoryNames =
      item.categories
        ?.map((cat) => {
          const category = categories.find((c) => c.id === cat.id);
          if (!category) return null;

          // format of one cell shown below (all in one cell)
          // category 1: sub 1, sub 2 \n catgeory 2: sub 3
          const subcategories =
            cat.subcategories
              ?.map((subc) => {
                return category.subcategories?.find((sc) => sc.id === subc.id)
                  ?.title;
              })
              .filter(Boolean) ?? [];

          if (subcategories.length === 0) return null;
          return `${category.title}: ${subcategories.join(', ')}`;
        })
        .filter(Boolean)
        .join('\n') ?? '';

    const rowValues = [
      item.linkType ?? LINK_TYPES.LINK,
      item.name,
      item.description,
      item.personalisationTags,
      linkTexts,
      linkUrls,
      item.image?.url,
      item.displayLabel,
      item.relevance,
      categoryNames,
      subcategoryNames,
      item.filters,
      item.tags,
      item.longDescription,
    ];

    return rowValues.map(escapeCSV).join(',');
  });

  return [headers.join(','), ...rows].join('\n');
};
